<template>
  <section class="gh-section gh-events-partners" id="partners">
    <div class="container">
      <el-row :gutter="10">
        <el-col :xs="24" :md="24">
          <p class="gh-center gh-section-heading pt-1">
            EVENT HOSTS
          </p>
          <p class="gh-center heading-1 gh-darkgrey">
            The 2022 Suicide Prevention Summit is brought to you by...
          </p>
        </el-col>
      </el-row>
      <el-row :gutter="10" :class="'pt-1'">
        <el-col :xs="24" :md="24">
          <el-row
            class="gh-xs-wrap"
            type="flex"
            justify="center"
            align="center"
          >
            <el-col
              class="gh-logo"
              :lg="19"
              :xs="24"
              v-for="(partner, index) in eventPartners.slice(0, 3)"
              :key="index"
            >
              <a
                :href="partner.url"
                class="gh-logo-act gh-logo-nbcc"
                target="_blank"
                ><img
                  width="250"
                  height="49"
                  :src="partner.logo"
                  :class="( partner.styleClass ? partner.styleClass  : '')"
                  alt="lps"
              /></a>
            </el-col>
          </el-row>

          <el-row
            class="gh-xs-wrap pt-1"
            type="flex"
            justify="center"
            align="center"
          >
            <el-col
              :class="'gh-logo'"
              :lg="19"
              :xs="24"
              v-for="(partner, index) in eventPartners.slice(3-5)"
              :key="index"
            >
              <a :href="partner.url" class="" target="_blank"
                ><img
                  width="190"
                  height="49"
                  :src="partner.logo"
                  :class="( partner.styleClass ? partner.styleClass  : '')"
                  alt="lps"
              /></a>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      eventPartners: [
        {
          logo: "/images/suicidePreventionSummit/MHA-Logo-colour.svg",
          url: "https://mentalhealthacademy.net/",
          name: "Mental Health Academy",
          styleClass: "gh-logo-img-extra"
        },
        {
          logo: "/images/suicidePreventionSummit/logos/ACA Logo.png",
          url: "//www.counseling.org/",
          name: "American Counseling Association",
          styleClass: "gh-logo-img-extra2"
        },
        {
          logo: "/images/suicidePreventionSummit/logos/AAS-LOGO.png",
          url: "//suicidology.org",
          name: "American Association of Suicidology ",
        },
        {
          logo: "/images/suicidePreventionSummit/NBCCFlogo.png",
          url: "https://www.nbccf.org/",
          name: "NBCC Foundation",
        },
        {
          logo: "/images/suicidePreventionSummit/ccpa-logo.png",
          url: "https://www.ccpa-accp.ca/",
          name: "CCPA",
        }
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.gh-events-partners {
  background: #F5F7FA;
  font-family: proxima-nova,sans-serif;
}
.heading-1 {
  font-size: 1.4rem;
  line-height: 1.2;
  margin-bottom: 20px;
  font-weight: bold;
  color: #474f59;
}
.gh-section-heading {
  color: #374785;
}
.pt-1 {
  padding-top: 1rem;
}
.gh-logo {
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  padding: 1rem;
  box-shadow: 0 0 10px #ccc;
  img {
    max-width: 260px;
  }
}

.gh-logo-img-extra {
  height: 47px !important;
  @media (max-width: 480px) {
    height: 100px !important;
  }
}

.gh-logo-img-extra2 {
  height: 54px !important;
  @media (max-width: 480px) {
    height: 70px !important;
  }
}

.el-col-lg-19 {
  width: 19%;
  margin-left: 20px;
  @media (max-width: 480px) {
    width: unset;
  }
}

.el-col-lg-24 {
  width: 24%;
  @media (max-width: 480px) {
    width: unset;
  }
}

.gh-xs-wrap {
  @media (max-width: 480px) {
    flex-wrap: wrap;
    padding-top: unset;
  }

}
.el-col-xs-24 {
  @media (max-width: 480px) {
  width: 100% !important;
  }
}

@media (max-width: 480px) {
  .gh-logo {
    margin-bottom: 1rem;
  }
}
</style>
